import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
var reactPlugin = new ReactPlugin();

var appInsights

(async () => {

    if(!window.env){
        await fetch('/settings.json',{
            headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
            }
        })
        .then(response =>  {
            return response.json();
            })
        .then((data) => window.env = data )
        .catch(error => console.error(error));
    }

    if(window.env.APPLICATIONINSIGHTS_CONNECTION_STRING) {
        appInsights = new ApplicationInsights({
            config: {
                connectionString: window.env.APPLICATIONINSIGHTS_CONNECTION_STRING,
                extensions: [reactPlugin],
                enableAutoRouteTracking: true,
                disableAjaxTracking: false,
                autoTrackPageVisitTime: true,
                enableCorsCorrelation: true,
                enableRequestHeaderTracking: true,
                enableResponseHeaderTracking: true,
            }
        });
        appInsights.loadAppInsights();
    }

    console.log(window.env)
})()


export { reactPlugin, appInsights };